<script>
import Sticky from '../sticky';
export default {
  name: 'zr-tabs',
  props: {
    defaultIndex: {
      default: 0,
      type: Number
    },
    onSelect: {
      type: Function
    }
  },
  components: {
    Sticky
  },
  data() {
    return {
      selectedIndex: this.defaultIndex,
      fixed: false
    };
  },
  methods: {
    switchTab(e, index, isDisabled) {
      if (!isDisabled) {
        this.selectedIndex = index;
        this.onSelect && this.onSelect(e, index);
      }
    },
    handleChange(active) {
      this.fixed = active;
    }
  },
  render() {
    const tabs = this.$slots.default.filter(component => component.componentOptions);

    const tabList = [];
    tabs.forEach((child, index) => {
      const { title, titleSlot, disabled } = child.componentOptions.propsData;
      const content = titleSlot ? this.$slots[titleSlot] : title;
      const isDisabled = disabled === true || disabled === '';

      tabList.push(
        <li
          class="zr-tab"
          role="tab"
          onClick={e => this.switchTab(e, index, isDisabled)}
          aria-selected={this.selectedIndex === index ? 'true' : 'false'}
          aria-disabled={isDisabled ? 'true' : 'false'}
        >
          {content}
        </li>
      );
    });

    return (
      <div staticClass="zr-tabs" role="tabs" class={this.fixed ? 'fixed' : ''}>
        <sticky class="sticky" className="sticky-inner" onChange={this.handleChange} isFull={true} stickyTop={25}>
          <ul class="zr-tablist" role="tablist">
            {this.$slots.left}
            {tabList}
            {this.$slots.right}
          </ul>
        </sticky>
        <transition name="fade" mode="out-in">
          {tabs[this.selectedIndex]}
        </transition>
      </div>
    );
  }
};
</script>

<style lang="scss">
  .sticky-inner {
    background-color: #fff;
    &.fixed {
      height: 58px !important;
      box-shadow: -12px 2px 10px 0px rgba(0,0,0,0.08);
    }
  }
</style>

<style lang="scss" scoped>

.zr-tabs {
  width: 100%;
  .sticky {
    width: 100%;
    height: 40px;
    background-color: #fff;
  }
  .zr-tablist {
    width: 1200px;
    margin: 25px auto 0; 
    list-style: none;
    display: flex;
    align-items: flex-end;
    padding-left: 0;
    height: 25px;
    .zr-tab {
      cursor: pointer;
      user-select: none;
      background-color: white;
      position: relative;
      margin-right: 60px;
      font-size: 18px;
      color: rgba(34,34,34,0.4);
      transition: 0.3s;
      vertical-align: bottom;
      &::after {
        content: '';
        position: absolute;
        bottom: -8px;
        left: 0;
        right: 0;
        height: 3px;
        width: 0;
        margin: auto;
        border-radius: 2px;
        transition: 0.3s;
        background-color: rgba(255, 150, 30, 1);
      }
      
      &[aria-selected='true'] {
        font-size: 22px;
        color: rgba(34,34,34, 1);
        font-weight: 500;
        &::after {
          width: 42px;
        }
      }
      &[aria-disabled='true'] {
        cursor: not-allowed;
        color: #999;
      }
    }
  }
}

</style>